import {IconButton, Tooltip} from "@mui/material";
import {Delete} from "@mui/icons-material";
import React from "react";
import {useTranslation} from "react-i18next";
import {ICellRendererParams} from "ag-grid-community";

const DeleteActionIcon = ({
                              styles,
                              action,
                              params
                          }: { styles: any, action: Function, params: ICellRendererParams }) => {

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    return (
        <Tooltip arrow title={t("pricing:tooltips.delete")} placement={"right-start"}>
            <IconButton
                aria-label="delete"
                onClick={() => action(params.data)}
                sx={styles}
            >
                <Delete/>
            </IconButton>
        </Tooltip>
    );
};

export default DeleteActionIcon;